import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { applyClasses, applyProps } from '../shared/js';
import styles from './accordion.module.scss';
import AccordionContent from './AccordionContent';
import AccordionItem from './AccordionItem';
import AccordionToggle from './AccordionToggle';

const Accordion = (props) => {
  return (
    <ul
      className={cn(
        styles.accordion,
        // eslint-disable-next-line react/prop-types
        props.className,
        applyClasses(props, styles)
      )}
      {...applyProps(props)}
    >
      {props.children}
    </ul>
  );
};

Accordion.propTypes = {
  /** Pass children elements to this element */
  children: PropTypes.node,
};

Accordion.defaultProps = {
  children: undefined,
};

Accordion.Content = AccordionContent;
Accordion.Item = AccordionItem;
Accordion.Toggle = AccordionToggle;
export default Accordion;
